var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.navigationTitleArr.length)?_c('div',{staticClass:"dzs-navigation-title-box"},[_c('ul',_vm._l((_vm.navigationTitleArr),function(item,index){return _c('li',{key:index},[_c('a',{staticClass:"elli1",class:[_vm.currentUrl == item ? 'active' : ''],attrs:{"href":'#' + item}},[_vm._v(_vm._s(item))])])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }